
window.AdminSmartInsightsDashboards = (function($, window, document) {
  var init = function () {
    initEnableButtons();
  };

  function initEnableButtons() {
    $("body").on("click", ".dashboard-new-button", function(e) {
      e.preventDefault();
      var button = $(this);
      var dashboardId = button.data('dashboard-id');
      return enableDashboard(dashboardId);
    });
  }

  function enableDashboard(dashboardId) {
    var button = $(`.dashboard-new-button[data-dashboard-id="${dashboardId}"]`);
    var row = button.closest('tr');

    $.get(button.attr('href'))
      .then(function(html) {
        row.after(html);
        row.hide();
      })
      .fail(function(error) {
        console.error('Error loading enable form:', error);
      });
  }

  return {
    init: init
  };

})(jQuery, window, document);
